import React, { useEffect, useState } from 'react';
import { Button, Radio } from '@mui/material';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { changeEmployerSubscriptionPlan, getSubscriptionPlansList } from '../redux/actions/commonActions';
import { getSingleEmployerData } from '../redux/actions/employerActions';

const customModalStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 1000,
        marginTop: '2em'
    },
    content: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '8px',
        maxWidth: '40%',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
    },
};

const AssignSubscriptionPlanModal = ({ open, onClose, employerId, activePlan }) => {
    const dispatch = useDispatch();
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    const subscriptionPlans = useSelector((state) => state.common.subscriptionPlans);

    useEffect(() => {
        dispatch(getSubscriptionPlansList());
    }, []);

    const handlePlanSave = async () => {
        let payload = {
            "employerId": employerId,
            "planId": selectedPlan?.id
        }
        setIsSaving(true);
        await dispatch(changeEmployerSubscriptionPlan(payload));
        dispatch(getSingleEmployerData(employerId));
        setIsSaving(false);
        onClose();
    }

    const handleSelectPlan = (subPlan) => {
        if (activePlan?.planId == subPlan?.id) {
            return;
        }
        setSelectedPlan(subPlan);
    }

    return (
        <>
            <ReactModal
                isOpen={open}
                onRequestClose={onClose}
                contentLabel="Assign Subscription Plan Modal"
                style={customModalStyles}
            >
                <div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Change Subscription Plan:</span>
                    </div>

                    <div style={{}}>
                        {subscriptionPlans?.data?.length > 0 &&
                            <table className='ProfileTables' style={{ width: '100%', borderCollapse: 'collapse', marginTop: '0.5rem' }}>
                                <thead style={{ backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>
                                    <tr>
                                        <th><strong></strong></th>
                                        <th><strong>Plan Name</strong></th>
                                        <th><strong>Allowed Job Posts</strong></th>
                                        <th><strong>Total Months</strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subscriptionPlans?.data?.map((subPlan) => (
                                        <tr key={subPlan.id} onClick={() => handleSelectPlan(subPlan)}>
                                            <td>
                                                <Radio
                                                    size="small"
                                                    checked={selectedPlan?.id == subPlan?.id}
                                                    disabled={activePlan?.planId == subPlan?.id}
                                                />
                                            </td>
                                            <td>{subPlan.planName}</td>
                                            <td>{subPlan.noOfJobPosts}</td>
                                            <td>{subPlan.totalMonths}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        }
                    </div>

                    <div style={{ marginTop: '24px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ width: '120px' }}
                            size='small'
                            variant='outlined'
                            onClick={onClose}
                        >Cancel</Button>
                        <Button
                            style={{ marginLeft: '12px', width: '120px' }}
                            size='small'
                            variant='contained'
                            onClick={handlePlanSave}
                            disabled={!selectedPlan}
                        >{isSaving ? 'Saving' : 'Save'}</Button>

                    </div>

                </div>
            </ReactModal>
        </>
    );
};

export default AssignSubscriptionPlanModal;
